import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdaptFeatureModule } from "@common/feature/feature.module";
import { AdaptImplementationKitModule } from "@common/implementation-kit/implementation-kit.module";
import { AdaptShellModule } from "@common/shell/shell.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleModule } from "@common/ux/collapsible/collapsible.module";
import { ColourPickerComponent } from "@common/ux/colour-picker/colour-picker.component";
import { AdaptDashboardElementModule } from "@common/ux/dashboard-element/dashboard-element.module";
import { AdaptEntityValidatorModule } from "@common/ux/entity-validator/entity-validator.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { IconPickerComponent } from "@common/ux/icon-picker/icon-picker.component";
import { AdaptIncompleteWorkModule } from "@common/ux/incomplete-work/incomplete-work.module";
import { AdaptLinkDisabledModule } from "@common/ux/link-disabled/link-disabled.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptStopPropagationDirective } from "@common/ux/stop-propagation.directive";
import { AdaptStyledDashboardElementModule } from "@common/ux/styled-dashboard-element/styled-dashboard-element.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptUniversalDashboardElementModule } from "@common/ux/universal-dashboard-element/universal-dashboard-element.module";
import { TeamCardComponent } from "@org-common/lib/architecture/organisation-map/team-card/team-card.component";
import { AdaptAuthorisationModule } from "@org-common/lib/authorisation/authorisation.module";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { AdaptFeaturesModule } from "@org-common/lib/features/features.modules";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";
import { AdaptTeamDashboardSharedModule } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.module";
import { AdaptZoneMapModule } from "@org-common/lib/zone-map/zone-map.module";
import { DxCheckBoxModule, DxListModule, DxRadioGroupModule, DxSelectBoxModule, DxSortableModule, DxTextBoxModule, DxTreeViewModule } from "devextreme-angular";
import { AdaptCallToActionModule } from "../call-to-action/call-to-action.module";
import { ChangeTeamAppearanceDialogComponent } from "./change-team-appearance-dialog/change-team-appearance-dialog.component";
import { ConfigureTeamStewardshipComponent } from "./configure-team-stewardship/configure-team-stewardship.component";
import { ConfigureTeamStewardshipDialogComponent } from "./configure-team-stewardship-dialog/configure-team-stewardship-dialog.component";
import { DisplayTeamTypeComponent } from "./display-team-type/display-team-type.component";
import { EditTeamLocationsComponent } from "./edit-team-locations/edit-team-locations.component";
import { EditTeamLocationsDialogComponent } from "./edit-team-locations-dialog/edit-team-locations-dialog.component";
import { MeetingBehavioursAgendaItemComponent } from "./meeting-behaviours-agenda-item/meeting-behaviours-agenda-item.component";
import { SelectTeamTypeComponent } from "./select-team-type/select-team-type.component";
import { TeamAccountabilitiesDashboardElementComponent } from "./team-accountabilities-dashboard-element/team-accountabilities-dashboard-element.component";
import { TeamDisplayConfigurationComponent } from "./team-display-configuration/team-display-configuration.component";
import { TeamHierarchyDashboardElementComponent } from "./team-hierarchy-dashboard-element/team-hierarchy-dashboard-element.component";
import { TeamLocationDashboardElementComponent } from "./team-location-dashboard-element/team-location-dashboard-element.component";
import { TeamMeetingGuidanceDashboardElementComponent } from "./team-meeting-guidance-dashboard-element/team-meeting-guidance-dashboard-element.component";
import { TeamMembershipComponent } from "./team-membership/team-membership.component";
import { TeamPeopleDashboardElementComponent } from "./team-people-dashboard-element/team-people-dashboard-element.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AdaptTooltipModule,
        AdaptButtonModule,
        AdaptLoadingSpinnerModule,
        AdaptCommonDialogModule,
        AdaptDirectorySharedModule,
        AdaptIncompleteWorkModule,
        AdaptFeaturesModule,
        AdaptLoadingSpinnerModule,
        AdaptShellModule,
        AdaptAuthorisationModule,
        AdaptZoneMapModule,
        AdaptTeamDashboardSharedModule,
        DxSortableModule,
        DxSelectBoxModule,
        DxListModule,
        DxTextBoxModule,
        DxCheckBoxModule,
        AdaptHtmlEditorModule,
        AdaptEntityValidatorModule,
        AdaptMenuModule,
        AdaptDashboardElementModule,
        AdaptCallToActionModule,
        AdaptImplementationKitModule,
        AdaptStyledDashboardElementModule,
        AdaptFeatureModule,
        AdaptCollapsibleModule,
        AdaptUniversalDashboardElementModule,
        AdaptStopPropagationDirective,
        DxRadioGroupModule,
        DxTreeViewModule,
        AdaptLinkDisabledModule,
        ColourPickerComponent,
        IconPickerComponent,
        TeamCardComponent,
        DisplayTeamTypeComponent,
        TeamMembershipComponent,
    ],
    exports: [
        TeamMembershipComponent,
        TeamPeopleDashboardElementComponent,
        TeamMeetingGuidanceDashboardElementComponent,
        ConfigureTeamStewardshipDialogComponent,
        MeetingBehavioursAgendaItemComponent,
        TeamAccountabilitiesDashboardElementComponent,
        SelectTeamTypeComponent,
        TeamDisplayConfigurationComponent,
        TeamLocationDashboardElementComponent,
        EditTeamLocationsComponent,
        TeamHierarchyDashboardElementComponent,
    ],
    declarations: [
        TeamPeopleDashboardElementComponent,
        TeamMeetingGuidanceDashboardElementComponent,
        ConfigureTeamStewardshipDialogComponent,
        ConfigureTeamStewardshipComponent,
        MeetingBehavioursAgendaItemComponent,
        TeamAccountabilitiesDashboardElementComponent,
        SelectTeamTypeComponent,
        TeamDisplayConfigurationComponent,
        EditTeamLocationsComponent,
        EditTeamLocationsDialogComponent,
        ChangeTeamAppearanceDialogComponent,
        TeamLocationDashboardElementComponent,
        TeamHierarchyDashboardElementComponent,
    ],
})

export class AdaptCommonTeamsModule {
    // prevent being optimised by tree-shaker
    public readonly workflowStepComponents = [
        MeetingBehavioursAgendaItemComponent,
    ];

    constructor(authorisationService: AuthorisationService) {
        CommonTeamsAuthService.registerAccess(authorisationService);
    }
}

